module.exports = __webpack_public_path__ + "img/bm-google-sat.3be168c2.png";